<template>
  <div class="info">
    <div class="time">
      <div
        class="examinationInfo"
        v-if="examinationInfo != null && routeName == 'detail'"
      >
        <div class="cell">
          <img src="../../assets/img/icon_5.png" />
          <div class="name">科目</div>
          <el-input
            v-model="examinationInfo.examinationCoursesName"
            placeholder=""
            readonly
          ></el-input>
        </div>
        <div class="cell">
          <img src="../../assets/img/icon_4.png" />
          <div class="name">考试时长</div>
          <el-input
            v-model="examinationInfo.examinationMinute"
            placeholder=""
            readonly
          ></el-input>
        </div>
        <div class="cell">
          <img src="../../assets/img/icon_4.png" />
          <div class="name">剩余时长</div>
          <el-input v-model="countdown" placeholder="" readonly></el-input>
        </div>
      </div>
    </div>

    <div class="page" id="page">
      <div class="left">
        <div
          class="item"
          :class="{ active: isActive == 'singx' }"
          @click="switchItem('singx')"
          v-if="SingXList.length > 0"
        >
          <img
            v-if="subjectType === 'singx'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>单选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'multx' }"
          @click="switchItem('multx')"
          v-if="MultXList.length > 0"
        >
          <img
            v-if="subjectType === 'multx'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>多选题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'judgex' }"
          @click="switchItem('judgex')"
          v-if="JudgXList.length > 0"
        >
          <img
            v-if="subjectType === 'judgex'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>判断题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'fillx' }"
          @click="switchItem('fillx')"
          v-if="FillXList.length > 0"
        >
          <img
            v-if="subjectType === 'fillx'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>填空题</div>
        </div>
        <div
          class="item"
          @click="switchItem('proofx')"
          v-if="ProofXList.length > 0"
        >
          <img
            v-if="subjectType === 'proofx'"
            :class="{ active: isActive == 'proofx' }"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>证明题</div>
        </div>
        <div
          class="item"
          :class="{ active: isActive == 'anwsx' }"
          @click="switchItem('anwsx')"
          v-if="AnwsXList.length > 0"
        >
          <img
            v-if="subjectType === 'anwsx'"
            src="../../assets/img/icon_shu.png"
          />
          <img v-else src="../../assets/img/icon_shu_2.png" />
          <div>计算题</div>
        </div>
        <!-- 左侧按钮 -->
        <div class="btnBox">
          <el-button
            type="primary"
            style="margin-left: 0"
            @click="submitFunc"
            :loading="submitLoading"
            >交卷</el-button
          >
        </div>
      </div>
      <!-- 上面的结构是一样的 -->
      <!-- 中间题目切换区域 -->
      <div
        class="center"
        :class="{ active1: active }"
        :style="{ height: contentHeight + 'px' }"
      >
        <div v-if="subjectType === 'singx'">
          <div
            v-for="(item, index) in SingXList"
            :key="index"
            @click="singxIndexChange(index)"
            class="wrap"
          >
            <!-- :key="item.id" -->
            <span
              class="item"
              :class="{ blue: singIndex[index] !== '' }"
              :x-id="item.serialnumber"
              >单选题{{ index + 1 }}
              <!--[{{item.knowledgeID+item.qID}}]-->
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'multx'">
          <div
            v-for="(item, index) in MultXList"
            :key="item.id"
            @click="multiIndexChange(index)"
            class="wrap"
          >
            <!-- 多选蓝色？ -->
            <span
              class="item"
              :class="{ blue: MultXList[index].answers.length !== 0 }"
              :x-id="item.serialnumber"
              >多选题{{ index + 1 }}
            </span>
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'judgex'">
          <div
            v-for="(item, index) in JudgXList"
            :key="item.id"
            @click="judgexChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: judgIndex[index] !== '' }"
              :x-id="item.serialnumber"
              >判断题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'fillx'">
          <div
            v-for="(item, index) in FillXList"
            :key="item.id"
            @click="fillxChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: FillXList[index].answers !== undefined }"
              :x-id="item.serialnumber"
              >填空题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'proofx'">
          <div
            v-for="(item, index) in ProofXList"
            :key="item.id"
            @click="proofxChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: ProofXList[index].answers !== undefined }"
              :x-id="item.serialnumber"
              >证明题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
        <div v-if="subjectType === 'anwsx'">
          <div
            v-for="(item, index) in AnwsXList"
            :key="item.id"
            @click="anwsxChange(index)"
            class="wrap"
          >
            <span
              class="item"
              :class="{ blue: AnwsXList[index].answers !== undefined }"
              :x-id="item.serialnumber"
              >计算题{{ index + 1 }}</span
            >
            <img
              class="selected"
              v-show="index === subjectIndex"
              src="../../assets/img/icon_fanhui.png"
            />
          </div>
        </div>
      </div>
      <!-- 右侧题目区域 -->
      <div class="right">
        <div class="item">
          <div
            class="title"
            v-if="subjectType === 'singx' && SingXList.length > 0"
          >
            <!-- 题目信息区域 -->
            <!-- <div class="html" v-html="SingXList[subjectIndex].steam"></div> -->
            <!-- 单选 -->
            <div
              v-for="(item, index) in SingXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 答案选择区域 -->
          <div
            class="groupbox"
            v-if="subjectType === 'singx' && SingXList.length > 0"
          >
            <!-- 数选项绑定的数据 v-model="singIndex[subjectIndex]"暂时不修改-->
            <el-radio-group
              v-model="singIndex[subjectIndex]"
              class="el_radio_group"
              @change="SingXListFnc(singIndex[subjectIndex])"
            >
              <div
                v-for="(item, index) in SingXList1[subjectIndex].options"
                :key="index"
              >
                <el-radio :label="orderList[index].label" class="el_radio">
                  <span class="labelbox"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span v-for="(t, i) in item.ranginfos" :key="i">
                    <span v-for="(it, j) in t.wordInfos" :key="j">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                </el-radio>
                <br />
              </div>
            </el-radio-group>
          </div>
          <!-- 多选 -->
          <div class="title" v-if="subjectType === 'multx'">
            <!-- <div class="html" v-html="MultXList[subjectIndex].steam"></div> -->
            <!-- 题目信息 -->
            <div
              v-for="(item, index) in MultXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div v-if="subjectType === 'multx'">
            <!-- 选项绑定临时数据multipleTemp暂不修改  -->
            <el-checkbox-group
              v-model="multipleTemp"
              class="el_radio_group"
              @change="MultXListChange($event, subjectIndex)"
            >
              <div
                class="multx"
                v-for="(item, index) in MultXList1[subjectIndex].options"
                :key="index"
              >
                <el-checkbox
                  :label="orderList[index].label"
                  class="el_radio"
                  :key="index"
                >
                  <span class="labelbox"
                    >{{ orderList[index].label }}.{{ str }}</span
                  >
                  <span v-for="(t, i) in item.ranginfos" :key="i">
                    <span v-for="(it, j) in t.wordInfos" :key="j">
                      <span v-if="it.wdType === 1" v-katex
                        >${{ it.latex }}$</span
                      >
                      <img v-else-if="it.wdType === 2" :src="it.buffer" />
                      <span v-else>{{ it.content }}</span>
                    </span>
                  </span>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
          <!-- 判断 -->
          <div class="title" v-if="subjectType === 'judgex'">
            <!-- <div class="html" v-html="JudgXList[subjectIndex].steam"></div> -->
            <div
              v-for="(item, index) in JudgXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <div v-if="subjectType === 'judgex'">
            <!-- 绑定数据暂不修改 -->
            <el-radio-group
              v-model="judgIndex[subjectIndex]"
              class="el_radio_group"
              @change="JudgXListFnc(judgIndex[subjectIndex])"
            >
              <el-radio :label="1" class="el_radio">
                <!-- 判断正确和错误选项改成了图标 -->
                <span class="box"><i class="el-icon-circle-check"></i></span>
              </el-radio>
              <br />
              <el-radio :label="0" class="el_radio">
                <span class="box"><i class="el-icon-circle-close"></i></span>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 填空 -->
          <div class="title" v-if="subjectType === 'fillx'">
            <!-- <div class="html" v-html="FillXList[subjectIndex].steam"></div> -->
            <!-- 题目信息 -->
            <div
              v-for="(item, index) in FillXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 证明 -->
          <div class="title" v-if="subjectType === 'proofx'">
            <!-- <div class="html" v-html="ProofXList[subjectIndex].steam"></div> -->
            <div
              v-for="(item, index) in ProofXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
          <!-- 计算 -->
          <div class="title" v-if="subjectType === 'anwsx'">
            <!-- <div class="html" v-html="AnwsXList[subjectIndex].steam"></div> -->
            <div
              v-for="(item, index) in AnwsXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
              </span>
            </div>
          </div>
        </div>
        <!-- 底部题目切换区域 -->
        <div class="bottom">
          <el-button class="last" @click="last" type="primary"
            >上一题</el-button
          >
          <div>|</div>
          <el-button class="next" @click="next" type="primary"
            >下一题</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExaminationInfoById,
  subAnswer,
  uploadAnswer,
  getStudentExaminationList
} from "@/api/student";
//import Steam from "@/util/steam.js";
import { convertToFullQuestion } from "@/util/extraction.js";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
// import { getInfo, setInfo } from "@/util/session";
export default {
  name: "detail",
  data: function() {
    return {
      active: 0,
      isActive: "",
      str: "\u3000",
      list: [],
      radio: 3,
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      //只用作渲染的数据
      SingXList1: [],
      MultXList1: [],
      JudgXList1: [],
      ProofXList1: [],
      FillXList1: [],
      AnwsXList1: [],
      //
      subjectType: "singx",
      subjectIndex: 0,
      //
      singIndex: [],
      judgIndex: [],
      //
      orderList: [
        {
          value: 0,
          label: "A"
        },
        {
          value: 1,
          label: "B"
        },
        {
          value: 2,
          label: "C"
        },
        {
          value: 3,
          label: "D"
        },
        {
          value: 4,
          label: "E"
        },
        {
          value: 5,
          label: "F"
        },
        {
          value: 6,
          label: "G"
        },
        {
          value: 7,
          label: "H"
        },
        {
          value: 8,
          label: "I"
        }
      ],
      contentHeight: 0,
      submitLoading: false,
      examinationDiff: "",
      examinationSer: "",
      multipleTemp: [],
      // multiAns: [],
      examinationList: [],
      systemDate: "",
      startTime: "",
      studentInfo: {},
      index: 0
    };
  },
  mounted() {
    console.log("123");
    // this.index = getInfo();
    this.routeName = this.$route.name;
    // this.fnc();
    window.onbeforeunload = function() {
      return "quit?";
    };
    this.examinationDiff = this.$route.query.examinationDiff;
    this.examinationSer = this.$route.query.examinationSer;
    this.getDetail();
    //渲染公式
    this.$nextTick(function() {
      //这里要注意，使用$nextTick等组件数据渲染完之后再调用MathJax渲染方法，要不然会获取不到数据
      if (this.commonsVariable.isMathjaxConfig) {
        //判断是否初始配置，若无则配置。
        this.commonsVariable.initMathjaxConfig();
      }
      this.commonsVariable.MathQueue("page"); //传入组件id，让组件被MathJax渲染
    });
    this.contentHeight = document.body.clientHeight - 64;
    //考试时间
    var timer1 = setInterval(() => {
      let currentDate = new Date();
      let startTime = new Date(this.startTime);
      this.examinationList.map(item => {
        if (
          currentDate.getTime() - startTime.getTime() >
            item.examinationMinute * 60 * 1000 ||
          item.exam_sub
        ) {
          this.$alert("考试时间已结束", "提示");
          clearInterval(timer1);
          this.submit();
        }
        return item;
      });
    }, 60000);
  },
  //清除定时器
  destroyed() {
    clearInterval(this.interval);
  },
  computed: {
    ...mapState({
      examinationInfo: state => state.examination.examinationInfo,
      countdownTime: state => state.examination.countdownTime
    }),
    ...mapGetters(["countdown"])
  },
  watch: {
    countdownTime(value) {
      if (value === 0) {
        this.$alert("考试时间已结束", "提示", {
          confirmButtonText: "确认",
          // showClose: false,
          callback: () => {
            this.submit();
          }
        });
      }
    }
  },
  methods: {
    singxIndexChange(index) {
      this.subjectIndex = index;
      let arr = this.SingXList1[this.subjectIndex].options;
      //先置空,然后再渲染,解决选项显示不刷新的问题
      this.SingXList1[this.subjectIndex].options = [];
      let arrq = this.SingXList1[this.subjectIndex].steam;
      this.SingXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.SingXList1[this.subjectIndex].options = arr;
        this.SingXList1[this.subjectIndex].steam = arrq;
      });
    },
    judgexChange(index) {
      this.subjectIndex = index;
      let arr = this.JudgXList1[this.subjectIndex].steam;
      this.JudgXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.JudgXList1[this.subjectIndex].steam = arr;
      });
    },
    fillxChange(index) {
      this.subjectIndex = index;
      let arr = this.FillXList1[this.subjectIndex].steam;
      this.FillXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.FillXList1[this.subjectIndex].steam = arr;
      });
    },
    proofxChange(index) {
      this.subjectIndex = index;
      let arr = this.ProofXList1[this.subjectIndex].steam;
      this.ProofXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.ProofXList1[this.subjectIndex].steam = arr;
      });
    },
    anwsxChange(index) {
      this.subjectIndex = index;
      let arr = this.AnwsXList1[this.subjectIndex].steam;
      this.AnwsXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.AnwsXList1[this.subjectIndex].steam = arr;
      });
    },
    fnc() {
      getStudentExaminationList().then(res => {
        this.examinationList = res.data.examinationinfoResps;
        this.systemDate = res.data.systemDate;
        this.examinationList = this.examinationList.filter(item => {
          return item.id == this.$route.query.id;
        });
      });
    },
    //加载考试信息
    getDetail() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let params = {
        id: this.$route.query.id
      };
      getExaminationInfoById(params)
        .then(res => {
          //console.log(res)
          //考试开始时间
          this.startTime = res.data.startTime;
          //通过调用vuex里面的方法,去计算考试剩余的时间
          this.$store.commit("setExaminationInfo", {
            examinationCoursesName: this.$route.query.examinationCoursesName,
            examinationMinute: this.$route.query.examinationMinute, //考试时长
            startTime: this.startTime //进入考试时间
          });
          //调用vuex里面的方法,倒计时
          this.interval = setInterval(() => {
            this.$store.commit("countdownTimeMinus");
          }, 1000);
          //console.log(res.data.list);
          //只用做渲染 start
          let arrs = res.data.list.map(item => {
            return convertToFullQuestion(item); //解析时,是旧的数据没有js的,就传第二个参数为1,调用另一个方法
          });
          this.JudgXList1 = arrs.filter(item => {
            return item.subjectType === "JudgX";
          });

          this.FillXList1 = arrs.filter(item => {
            return item.subjectType === "FillX";
          });
          this.FillXList1 = this.FillXList1.sort((a, b) => a.id > b.id);
          this.ProofXList1 = arrs.filter(item => {
            return item.subjectType === "ProofX";
          });
          this.ProofXList1 = this.ProofXList1.sort((a, b) => a.id > b.id);
          this.AnwsXList1 = arrs.filter(item => {
            return item.subjectType === "AnwsX";
          });
          this.AnwsXList1 = this.AnwsXList1.sort((a, b) => a.id > b.id);
          this.SingXList1 = arrs.filter(item => {
            return item.subjectType === "SingX";
          });
          this.MultXList1 = arrs.filter(item => {
            return item.subjectType === "MultX";
          });
          //添加选项文本标签，用户答案0123，转abcd
          this.SingXList = this.SingXList1.map(item => {
            item.answerIndex = item.order.split(",").map((x, index) => {
              let l = {};
              l.value = x;
              l.name = "ABCDEFGHIJKLMN".substr(index, 1);
              return l;
            });

            let fditem = item.answerIndex.find(answeritem => {
              return answeritem.value == item.usr_choice;
            });
            if (fditem == undefined) {
              item.usr_choice = "";
            } else {
              item.usr_choice = fditem.name;
            }
            item.answers = item.usr_choice;
            return item;
          });
          //单选历史选择结果放到singxlist
          this.SingXList.forEach(item => {
            if (item.answers) {
              this.singIndex.push(item.answers);
            } else {
              this.singIndex.push("");
            }
          });
          // console.log("this.SingXList", this.SingXList);
          //多选题标签，多选user_choice转abc，注意答案是array
          this.MultXList = this.MultXList1.map(item => {
            let item1 = { ...item };
            item1.answerIndex = item1.order.split(",").map((x, index) => {
              let l = {};
              l.value = x;
              l.name = "ABCDEFGHIJKLMN".substr(index, 1);
              return l;
            });
            let answs = [];
            let usrchs = item.usr_choice.split(",");
            usrchs.forEach(usr_ch => {
              let tempAnswer = item1.answerIndex.find(answeritem => {
                return answeritem.value == usr_ch;
              });
              if (typeof tempAnswer !== "undefined") {
                answs.push(tempAnswer.name);
              }
            });

            item1.answers = answs;
            return item1;
          });
          this.JudgXList = this.JudgXList1.map(item => {
            let item1 = { ...item };
            return item1;
          });
          this.JudgXList.forEach(item => {
            item.usr_choice = item.usr_choice.toString();
            item.order = 0;
            if (item.usr_choice === "1") {
              item.answers = 1;
            } else if (item.usr_choice === "0") {
              item.answers = 0;
            } else {
              item.answers = "";
            }
            return item;
          });
          this.JudgXList.forEach(item => {
            this.judgIndex.push(item.answers);
          });

          this.ProofXList = this.list.filter(item => {
            return item.qtype === "ProofX";
          });

          this.FillXList = this.list.filter(item => {
            return item.qtype === "FillX";
          });

          this.AnwsXList = this.list.filter(item => {
            return item.qtype === "AnwsX";
          });

          this.$nextTick(() => {
            this.setImageWidth();
          });
        })
        .finally(() => {
          loading.close();
        });
    },
    setImageWidth() {
      let subjectImg = [];
      let imgs = document.getElementsByTagName("img");
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].className == "subjectImage") {
          subjectImg.push(imgs[i]);
        }
      }
      subjectImg.forEach(item => {
        item.style.zoom = "50%";
      });
    },

    switchItem(type) {
      this.active = 1;
      this.isActive = type;
      this.subjectType = type;
      this.subjectIndex = 0;
      if (type === "singx") {
        let arr = this.SingXList1[this.subjectIndex].options;
        this.SingXList1[this.subjectIndex].options = [];
        let arrq = this.SingXList1[this.subjectIndex].steam;
        this.SingXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.SingXList1[this.subjectIndex].options = arr;
          this.SingXList1[this.subjectIndex].steam = arrq;
        });
      }
      if (type === "multx") {
        let arr = this.MultXList1[this.subjectIndex].options;
        this.MultXList1[this.subjectIndex].options = [];
        let arrq = this.MultXList1[this.subjectIndex].steam;
        this.MultXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.MultXList1[this.subjectIndex].options = arr;
          this.MultXList1[this.subjectIndex].steam = arrq;
        });
      }
      if (type === "judgex") {
        let arr = this.JudgXList1[this.subjectIndex].steam;
        this.JudgXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.JudgXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "fillx") {
        let arr = this.FillXList1[this.subjectIndex].steam;
        this.FillXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.FillXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "proofx") {
        let arr = this.ProofXList1[this.subjectIndex].steam;
        this.ProofXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.ProofXList1[this.subjectIndex].steam = arr;
        });
      }
      if (type === "anwsx") {
        let arr = this.AnwsXList1[this.subjectIndex].steam;
        this.AnwsXList1[this.subjectIndex].steam = [];
        this.$nextTick(() => {
          this.AnwsXList1[this.subjectIndex].steam = arr;
        });
      }
      if (this.subjectType === "multx") {
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    //选择答案时的处理
    SingXListFnc(val) {
      //console.log("id", this.SingXList[this.subjectIndex].id);
      this.SingXList[this.subjectIndex].answers = val;
      let index = "";
      // if (val == "A") {
      //   index = "0";
      // } else if (val == "B") {
      //   index = "1";
      // } else if (val == "C") {
      //   index = "2";
      // } else if (val == "D") {
      //   index = "3";
      // } else if (val == "E") {
      //   index = "4";
      // }
      let tempAnswer = this.SingXList[this.subjectIndex].answerIndex.find(
        item => item.name == val
      );
      index = tempAnswer.value;
      const list = {
        answer: index,
        correctOrder: this.SingXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.SingXList[this.subjectIndex].id,
        knowledgeID: this.SingXList[this.subjectIndex].knowledgeID,
        order: this.SingXList[this.subjectIndex].order,
        qid: this.SingXList[this.subjectIndex].qID,
        qtype: this.SingXList[this.subjectIndex].qtype,
        score: this.SingXList[this.subjectIndex].score
        // usr_choice: index
      };
      //console.log("upload-answer",list)
      uploadAnswer([list]).then(res => {
        console.log(res);
      });
    },
    JudgXListFnc(val) {
      this.JudgXList[this.subjectIndex].orders = val;
      const list = {
        answer: val,
        correctOrder: this.JudgXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.JudgXList[this.subjectIndex].id,
        knowledgeID: this.JudgXList[this.subjectIndex].knowledgeID,
        order: this.JudgXList[this.subjectIndex].order,
        qid: this.JudgXList[this.subjectIndex].qID,
        qtype: this.JudgXList[this.subjectIndex].qtype,
        score: this.JudgXList[this.subjectIndex].score
      };
      //console.log("upload-judex", list);
      uploadAnswer([list]).then(res => {
        console.log(res);
      });
    },
    last() {
      if (this.subjectIndex === 0) {
        return;
      }

      this.subjectIndex = this.subjectIndex - 1;
      if (this.subjectType === "singx") {
        this.singxIndexChange(this.subjectIndex);
      }
      if (this.subjectType === "judgex") {
        this.judgexChange(this.subjectIndex);
      }
      if (this.subjectType === "fillx") {
        this.fillxChange(this.subjectIndex);
      }
      if (this.subjectType === "proofx") {
        this.proofxChange(this.subjectIndex);
      }
      if (this.subjectType === "anwsx") {
        this.anwsxChange(this.subjectIndex);
      }
      if (this.subjectType === "multx") {
        this.multiIndexChange(this.subjectIndex);
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    next() {
      if (
        this.subjectType === "singx" &&
        this.subjectIndex < this.SingXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.singxIndexChange(this.subjectIndex);
      } else if (
        this.subjectType === "multx" &&
        this.subjectIndex < this.MultXList.length - 1
      ) {
        this.subjectIndex = this.subjectIndex + 1;
        this.multiIndexChange(this.subjectIndex);
      } else if (
        this.subjectType === "judgex" &&
        this.subjectIndex < this.JudgXList.length - 1
      ) {
        const list = {
          answer: this.judgIndex[this.subjectIndex],
          correctOrder: this.JudgXList[this.subjectIndex].correctOrder,
          examinationDiff: this.$route.query.examinationDiff,
          examinationSer: this.$route.query.examinationSer,
          id: this.JudgXList[this.subjectIndex].id,
          knowledgeID: this.JudgXList[this.subjectIndex].knowledgeID,
          order: this.JudgXList[this.subjectIndex].order,
          qid: this.JudgXList[this.subjectIndex].qid,
          qtype: this.JudgXList[this.subjectIndex].qtype,
          score: this.JudgXList[this.subjectIndex].score
        };
        uploadAnswer([list]).then(res => {
          console.log(res);
        });
        this.subjectIndex = this.subjectIndex + 1;
        this.judgexChange(this.subjectIndex);
      } else if (
        this.subjectType === "fillx" &&
        this.subjectIndex < this.FillXList.length - 1
      ) {
        const list = {
          answer: this.FillXList[this.subjectIndex].orders,
          correctOrder: this.FillXList[this.subjectIndex].correctOrder,
          examinationDiff: this.$route.query.examinationDiff,
          examinationSer: this.$route.query.examinationSer,
          id: this.FillXList[this.subjectIndex].id,
          knowledgeID: this.FillXList[this.subjectIndex].knowledgeID,
          order: this.FillXList[this.subjectIndex].order,
          qid: this.FillXList[this.subjectIndex].qid,
          qtype: this.FillXList[this.subjectIndex].qtype,
          score: this.FillXList[this.subjectIndex].score
        };
        uploadAnswer([list]).then(res => {
          console.log(res);
        });
        this.subjectIndex = this.subjectIndex + 1;
        this.fillxChange(this.subjectIndex);
      } else if (
        this.subjectType === "proofx" &&
        this.subjectIndex < this.ProofXList.length - 1
      ) {
        const list = {
          answer: this.ProofXList[this.subjectIndex].orders,
          correctOrder: this.ProofXList[this.subjectIndex].correctOrder,
          examinationDiff: this.$route.query.examinationDiff,
          examinationSer: this.$route.query.examinationSer,
          id: this.ProofXList[this.subjectIndex].id,
          knowledgeID: this.ProofXList[this.subjectIndex].knowledgeID,
          order: this.ProofXList[this.subjectIndex].order,
          qid: this.ProofXList[this.subjectIndex].qid,
          qtype: this.ProofXList[this.subjectIndex].qtype,
          score: this.ProofXList[this.subjectIndex].score
        };
        uploadAnswer([list]).then(res => {
          console.log(res);
        });
        this.subjectIndex = this.subjectIndex + 1;
        this.proofxChange(this.subjectIndex);
      } else if (
        this.subjectType === "anwsx" &&
        this.subjectIndex < this.AnwsXList.length - 1
      ) {
        const list = {
          answer: this.AnwsXList[this.subjectIndex].orders,
          correctOrder: this.AnwsXList[this.subjectIndex].correctOrder,
          examinationDiff: this.$route.query.examinationDiff,
          examinationSer: this.$route.query.examinationSer,
          id: this.AnwsXList[this.subjectIndex].id,
          knowledgeID: this.AnwsXList[this.subjectIndex].knowledgeID,
          order: this.AnwsXList[this.subjectIndex].order,
          qid: this.AnwsXList[this.subjectIndex].qid,
          qtype: this.AnwsXList[this.subjectIndex].qtype,
          score: this.AnwsXList[this.subjectIndex].score
        };
        uploadAnswer([list]).then(res => {
          console.log(res);
        });
        this.subjectIndex = this.subjectIndex + 1;
        this.anwsxChange(this.subjectIndex);
      }
      if (this.subjectType === "multx") {
        this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      }
    },
    submit() {
      let params = [];
      this.SingXList = this.SingXList.map(item => {
        if (item.answers) {
          let temp = "";
          item.answerIndex.forEach(item1 => {
            if (item1.name === item.answers) {
              temp = item1.value;
            }
          });
          item.answer = temp;
        } else {
          item.answer = "";
        }
        return item;
      });
      this.MultXList = this.MultXList.map(item => {
        if (item.answers) {
          let temp = _.cloneDeep(item.answers);
          for (var i in item.answers) {
            for (var j in item.answerIndex) {
              if (item.answers[i] === item.answerIndex[j].name) {
                temp[i] = item.answerIndex[j].value;
              }
            }
          }
          item.answer = temp.join(",");
        } else {
          item.answer = "";
        }
        return item;
      });
      // console.log("submit", this.MultXList);
      this.JudgXList = this.JudgXList.map(item => {
        // item.answer = ""
        item.answer = item.answers;
        return item;
      });
      params = _.cloneDeep(
        params.concat(
          this.SingXList,
          this.MultXList,
          this.JudgXList,
          this.FillXList,
          this.ProofXList,
          this.AnwsXList
        )
      ).map(item => {
        delete item.answerList;
        delete item.answerbuffer;
        delete item.comment;
        delete item.solve;
        delete item.solvebuffer;
        delete item.steam;
        delete item.steambuffer;
        delete item.updatetime;
        delete item.wdfont;
        delete item.answerIndex;
        delete item.answers;
        delete item.knowledgeName;
        delete item.level;
        delete item.questionTable;
        // delete item.score;
        //修改
        delete item.orders;
        delete item.answerjs;
        delete item.solvejs;
        delete item.steamjs;
        delete item.usr_choice;
        item.qid = item.qID;
        delete item.qID;
        item.examinationDiff = this.examinationDiff;
        //
        item.examinationSer = this.examinationSer;
        return item;
      });
      this.submitLoading = true;
      //console.log("params", params);
      subAnswer(params)
        .then(res => {
          // if(res.data.code !== 200) {
          //   this.$message.error(res.data.message);
          //   // return
          // }
          console.log(res);
          this.$message.success("交卷成功");
          if (res.code === 200) {
            let subscore = "客观题";
            subscore += res.data;
            subscore + "分";
            this.$alert(subscore, "提示", {
              confirmButtonText: "确认"
            });
          }
          window.onbeforeunload = null;
          this.$store.commit("reload", true);
          setTimeout(() => {
            //关闭当前窗口,如果是独立页面的跳转需要用这个方法,关闭当前页面
            // window.close();
            //修改 跳转到home
            this.$router.push("/home");
          }, 1000);
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    //多选题答案处理
    MultXListChange(value, index) {
      //把每一题的答案都加入的MultXList里面
      this.$set(this.MultXList[index], "answers", value);
      console.log("this.MultXList[index]", this.MultXList[index]);
      var list = "";
      value.forEach(valueitem => {
        let tempAnswer = this.MultXList[index].answerIndex.find(
          item => item.name == valueitem
        );
        list += `${tempAnswer.value},`;
      });
      //选项所对应的索引
      console.log("list", list);
      if (list.length > 0) {
        list = list.substr(0, list.length - 1);
      }
      var str = {
        answer: list,
        correctOrder: this.MultXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.MultXList[this.subjectIndex].id,
        knowledgeID: this.MultXList[this.subjectIndex].knowledgeID,
        order: this.MultXList[this.subjectIndex].order,
        qid: this.MultXList[this.subjectIndex].qID,
        qtype: this.MultXList[this.subjectIndex].qtype,
        score: this.MultXList[this.subjectIndex].score
      };
      // console.log("str", str);
      uploadAnswer([str]).then(res => {
        console.log(res);
      });
    },
    multiIndexChange(index) {
      // this.multiAns.push(this.multipleTemp);
      // console.log(" this.multiAns", this.multiAns);
      // console.log("this.multipleTemp", this.multipleTemp);
      this.subjectIndex = index;
      //arr是乱序序号数组
      let arr = this.MultXList1[this.subjectIndex].options;

      this.MultXList1[this.subjectIndex].options = [];
      let arrq = this.MultXList1[this.subjectIndex].steam;
      this.MultXList1[this.subjectIndex].steam = [];
      this.$nextTick(() => {
        this.MultXList1[this.subjectIndex].options = arr;
        this.MultXList1[this.subjectIndex].steam = arrq;
      });
      this.multipleTemp = this.MultXList[this.subjectIndex].answers;
      console.log(this.multipleTemp);
      // console.log("end", this.multipleTemp);
    },
    // singIndexChange(index){
    //     this.subjectIndex = index;
    //     // this.singIndex[this.subjectIndex] = this.SingXList[this.subjectIndex].answers
    // },
    // judgIndexChange(index){
    //     this.subjectIndex = index;
    //     // this.judgIndex[this.subjectIndex] = this.JudgXList[this.subjectIndex].answers
    // },
    submitFunc() {
      this.$confirm(
        "如提交试卷，将无法再次进入该试卷，试卷成绩将提交",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.submit();
        })
        .catch(() => {});
    },
    //乱序排序
    randomSortArray(arr) {
      var len = arr.length;
      for (var i = len - 1; i >= 0; i--) {
        var randomIndex = Math.floor(Math.random() * (i + 1));
        var temp = arr[randomIndex];
        arr[randomIndex] = arr[i];
        arr[i] = temp;
      }
      return arr;
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  display: flex;
  font-size: 14px;
  width: 100%;
  .left {
    position: relative;
    width: 242px;
    .btnBox {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 40px;
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    .item {
      display: flex;
      padding: 20px 30px;
      // background: #f8fafb;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 15px;
        height: 20px;
      }
    }
  }
  .center {
    background: #f8fafb;
    width: 223px;
    height: 100%;
    // width: 100px;
    overflow: auto;
    .wrap {
      display: flex;
      padding: 10px 0;
      //justify-content: space-around;
      align-items: center;
      cursor: pointer;
    }
    .item {
      white-space: nowrap;
      margin: 0 15px;
    }
    .blue {
      color: #006dfe;
    }
  }
  .right {
    flex-grow: 1;
    padding: 28px;
    background: #f8fafb;
    text-align: left;
    // width: 3300px;
    position: relative;
    .item {
      font-size: 14px;
      background: #fff;
      justify-content: left;
      padding: 26px 20px;
      // margin-top: 15px;
      .title {
        font-size: 20px;
        margin-bottom: 20px;
      }
      img {
        // 有图片的题目保持和文字居中对齐
        vertical-align: middle;
      }
    }
  }
  // .multx {
  //   width: 100%;
  //   white-space: nowarp;
  //   overflow-x: auto;
  //   margin-left: 20px;
  // }
  .el_radio_group {
    //display: flex;
    font-size: 14px;
    flex-wrap: wrap;
    .el_radio {
      // width: 45%;
      padding: 15px;
      // border-bottom: solid 1px #eee;
      display: flex;
      align-items: center;
    }
  }
}
.bottom {
  position: absolute;
  bottom: 0;
  width: 1015px;
  margin: 0 auto;
  // background: #fff;
  height: 40px;
  display: flex;
  line-height: 40px;
  justify-content: center;
  .last,
  .next {
    margin: 0 100px;
    cursor: pointer;
  }
}
.info {
  position: relative;
  .time {
    position: absolute;
    top: -55px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    // border-bottom: 2px solid #f8fafb;
    flex-grow: 1;
    flex-direction: row-reverse;
    align-items: center;
    display: flex;
  }
  .examinationInfo {
    display: flex;
    .cell {
      display: flex;
      align-items: center;
      margin: 0 5px;
      .name {
        white-space: nowrap;
        margin: 0 15px;
      }
    }
  }
}
// 多选的框隐藏
::v-deep .el-checkbox__inner {
  display: none;
}
.box {
  font-size: 40px;
}
.active {
  background-color: #f8fafb;
}
::v-deep .el_radio_group .el-radio__label {
  font-size: 18px;
}
::v-deep .el_radio_group .el-checkbox__label {
  font-size: 18px;
}

::v-deep .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-radio__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .groupbox .el-radio .el-radio__input:hover {
  border-color: #409eff;
}
::v-deep .groupbox .el-radio .el-radio__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
// ::v-deep .el-checkbox .el_radio {
//   padding-left: 20px;
// }
.labelbox {
  margin-left: -40px;
  // line-height: 40px;
  vertical-align: middle;
}
::v-deep .el-checkbox__label {
  padding-top: 5px;
}
::v-deep .el-checkbox .el_radio {
  vertical-align: middle;
}
::v-deep .el-icon-circle-close:hover {
  color: #409eff;
}
::v-deep .el-icon-circle-check:hover {
  color: #409eff;
}
::v-deep .katex {
  font-size: 24px;
}
.active1 {
  width: 100px !important;
}
</style>
